import { Container, Row } from "reactstrap";
import { FormLayoutTitle, FormWidgetsTitle } from "../../../../../constants";
import NumberingWizard from "./numberingWizard";
import ShippingForm from "./shippingForm";
import StudentValidationForm from "./studentValidationForm";
import VerticalValidationWizard from "./verticalValidationWizard";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const FormWizard1Container = () => {
  return (
    <>
      <Breadcrumbs mainTitle={FormWidgetsTitle} parent={FormLayoutTitle} />
      <Container fluid>
        <Row>
          <NumberingWizard />
          <StudentValidationForm />
          <VerticalValidationWizard />
          <ShippingForm />
        </Row>
      </Container>
    </>
  );
};
export default FormWizard1Container;
